import type { Merchant } from '../model/merchant';

export interface MerchantApi {
  getMerchants: () => Promise<Merchant[]>;
}

export const MERCHANT_API_KEY = 'merchantApi';
